import {EmailProviderResponseBody} from '@dms/api/core';

export type EmailServiceProvider = EmailProviderResponseBody;
